<template>
  <div class="rightconover">
    <div class="contentwidth">
      <div class="ContentMargin">
        <div class="content_top">
          <div class="content_head">
            <div class="content_head_ico">
              <img src="@/assets/images/estorage/content_title_ico_blue.png" alt=""/>
            </div>
            <div class="content_head_title">
              基本信息
            </div>
            <div class="content_head_button">
              <div class="content_head_seek">
                <lk-button img="save.png" @click="uploadButton()" v-show="AddState!==1">保存</lk-button>
              </div>
              <div class="content_head_seek">
                <lk-button img="back.png" @click="goBack" type="lk_button_blue">返回</lk-button>
              </div>
            </div>
          </div>
          <div class="content_element">
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>货位名称</span>
                <span class="significance">*</span>
              </div>
              <el-input v-model="granaryData.name" placeholder="" maxlength="15"
                        :disabled="AddState === 1"></el-input>
            </div>
            <div class="content_element_only" v-if="AddState !== 0">
              <div class="content_element_only_title">
                <span>库存品种</span>
              </div>
              <el-input v-model="granaryData.grainKind" placeholder="" maxlength="15" disabled></el-input>
            </div>
            <div class="content_element_only" v-if="AddState !== 0">
              <div class="content_element_only_title">
                <span>粮食性质</span>
              </div>
              <el-input v-model="granaryData.grainNature" placeholder="" maxlength="15" disabled></el-input>
            </div>
            <div class="content_element_only" v-if="AddState !== 0">
              <div class="content_element_only_title">
                <span>粮权所属</span>
              </div>
              <el-input v-model="granaryData.grainBelong" placeholder="" maxlength="15" disabled></el-input>
            </div>
            <div class="content_element_only" v-if="AddState !== 0">
              <div class="content_element_only_title">
                <span>货位使用状态</span>
              </div>
              <el-input v-model="granaryData.barUseStatus" placeholder="" maxlength="15" disabled></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>货位状态</span>
              </div>
              <el-select v-model="granaryData.status" placeholder="" :disabled="AddState === 1">
                <el-option
                    v-for="item in stateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>货位代码</span>
                <span class="significance">*</span>
              </div>
              <el-input v-model="granaryData.number" placeholder="" maxlength="30" :disabled="AddState === 1"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>启用日期</span>
                <span class="significance">*</span>
              </div>
              <el-date-picker
                  v-model="granaryData.useDate"
                  type="date"
                  placeholder=""
                  value-format="yyyy-MM-dd"
                  :disabled="AddState === 1">
              </el-date-picker>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>廒间代码</span>
                <span class="significance">*</span>
              </div>
              <el-input v-model="granaryData.interNodeCode" placeholder="" maxlength="28" :disabled="AddState === 1"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>绑定仓房</span>
                <span class="significance">*</span>
              </div>
              <el-select v-model="granaryData.parentId" placeholder="" :disabled="AddState !== 0"
                         @change="getBarnInfoData(granaryData.parentId)">
                <el-option
                    v-for="item in storeroomList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="content_down content_top">
          <div class="content_element">
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>货位长度</span>
              </div>
              <el-input placeholder="" v-model="granaryData.length" :disabled="AddState === 1" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g,'$1')" @blur="granaryData.length = $event.target.value">
                <template slot="append">M</template>
              </el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>货位宽度</span>
              </div>
              <el-input placeholder="" v-model="granaryData.width" :disabled="AddState === 1" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g,'$1')" @blur="granaryData.width = $event.target.value">
                <template slot="append">M</template>
              </el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>货位高度</span>
              </div>
              <el-input placeholder="" v-model="granaryData.height" :disabled="AddState === 1" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g,'$1')" @blur="granaryData.height = $event.target.value">
                <template slot="append">M</template>
              </el-input>
            </div>
          </div>
        </div>
        <div class="content_down">
          <div class="content_element">
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>设计容量</span>
                <span class="significance">*</span>
              </div>
              <el-input placeholder="" v-model="granaryData.designSize" :disabled="AddState === 1"
                        oninput="value=value.replace(/[^\d]/g,'')" @blur="granaryData.designSize = $event.target.value">
                <template slot="append">kg</template>
              </el-input>
            </div>
            <div class="content_element_only" v-if="AddState !== 0">
              <div class="content_element_only_title">
                <span>实际容量</span>
                <span class="significance">*</span>
              </div>
              <el-input placeholder="" v-model="granaryData.actualSize" disabled>
                <template slot="append">kg</template>
              </el-input>
            </div>
            <div class="content_element_remark" v-if="barnInfoData!==''">
              <progressbar class="homeprogressbar" :progressbar_data="barnInfoData" ref="progressbar"></progressbar>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {httpToken} from '@/utils/http'
import qs from "qs";
import {getWarehouse} from "@/utils/warehouseInOut";
import progressbar from "@/components/gadgets/progressbar.vue";
import {handleMessage} from "@/utils/server/confirm";

export default {
  name: 'GranaryAdd',
  components: {
    progressbar,
  },
  data() {
    return {
      ids: '',
      granaryData: {
        name: '',
        number:'',//货位代码
        interNodeCode:'',//廒间代码
        grainKind: null,
        grainNature: null,
        grainBelong: null,
        status: 0,
        useDate: null,
        parentId: null,
        length: null,
        width: null,
        height: null,
        designSize: '',
        actualSize: null,
      },
      storeroomList: getWarehouse('id'),
      stateList: [
        {value: 0, label: '完好'},
        {value: 1, label: '损坏'}
      ],
      nowId:'',//当前仓房id
      nowbarnDSize:0,//当前仓房设计容量
      nowsumSize:0,//当前仓房已有容量
      AddState: 0,
      barnInfoData:'',
      codeVerificateStatus:false
    }
  },
  mounted() {
    if (this.$store.state.Manage.granaryState) {
      this.AddState = Number(this.$store.state.Manage.granaryState)
    }
    if (this.$store.state.Manage.granaryId) {
      this.ids = this.$store.state.Manage.granaryId
      this.getGranaryDate()
    }
  },
  methods: {
    // 上传按键
       uploadButton () {
      if (this.granaryData.number === ''||this.granaryData.number == null) {
        handleMessage('请输入货位代码')
        return
      }
      if (this.granaryData.interNodeCode === ''||this.granaryData.interNodeCode == null) {
        handleMessage('请输入廒间代码')
        return
      }
      this.codeVerificate().then((res)=>{
        //货位代码判断
        if(!res){
          handleMessage('请校验货位代码或廒间代码')  
          return
        }
        if (this.granaryData.name === '') {
          handleMessage('请填写货位名称')
          return
        } 
        if (this.granaryData.useDate === ''||this.granaryData.useDate == null) {
          handleMessage('请选择启用日期')
          return
        }

        if (!this.granaryData.parentId) {
          handleMessage('请选择绑定仓房')
          return
        } 
        if (this.granaryData.designSize === '') {
          handleMessage('请填写设计容量')
          return
        } 
        if((this.nowbarnDSize-this.nowsumSize)<this.granaryData.designSize){
          handleMessage('设计容量超出仓房剩余容量')
          return
        }
        this.$confirm('上传数据，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          if (this.AddState === 0) {
            this.addGranary()
          } else if (this.AddState === 2) {
            this.uploadGranary()
          }
        })
      }) 
 
    },
   compareStrings(str1, str2) {
    var substr1 = str1.substring(0, 18);
    var substr2 = str2.substring(0, 18); 
    console.log(substr1,substr2,'substr1substr1')
    if (substr1 == substr2) {
      return true
    } else {
       return false
    }
},
    //货位代码验证
    codeVerificate(){
      return new Promise(resolve => {  
        httpToken({
        url: '/maintain/data-dictionary/listSons',
        method: 'post',
        data: qs.stringify({
          'paramData':JSON.stringify([{column:"type_name",type:"eq",value:"codeVerificate"},{column:'name',type:'eq',value:JSON.parse(sessionStorage.user).unitId}]) ,
        }),
      }).then(res=>{
        let records=res.data.data.records
          if(records.length>1){
            handleMessage('当前货位前置代码字典中拥有多个代码请检查！')
            // return
            // this.codeVerificateStatus=false
            resolve(false);  
          }else if(records.length==0){
            // this.codeVerificateStatus=false
            httpToken({
              url: '/maintain/data-dictionary/listSons',
              method: 'post',
              data: qs.stringify({
                'paramData':JSON.stringify([{column:"type_name",type:"eq",value:"codeVerificate"},{column:'name',type:'eq',value:'other'}]) ,
              }),
            }).then(res2=>{
              let records2=res2.data.data.records
              if(records2.length>1){
                handleMessage('当前货位前置代码字典中拥有多个代码请检查！')
                // return
                // this.codeVerificateStatus=false
                resolve(false);  
              }else if(records2.length==0){
                handleMessage('当前货位前置代码不存在')
                // this.codeVerificateStatus=false
                resolve(false);  
                return
              }else{
                let Fresult2 = this.compareStrings(records2[0].value,this.granaryData.number)
                let Sresult2 = this.compareStrings(records2[0].value,this.granaryData.interNodeCode)
                if(Fresult2&&Sresult2){
                  resolve(true);  
                }else{
                  resolve(false); 
                }
              }
            })
            return
          }else{
            let Fresult= this.compareStrings(records[0].value,this.granaryData.number)
            let Sresult= this.compareStrings(records[0].value,this.granaryData.interNodeCode)
            if(Fresult&&Sresult){
              resolve(true);  
            }else{
              resolve(false); 
            }
          }
      })
 
    });  
    
    },
    // 上传添加货位数据
    addGranary() {
      let _this = this
      delete this.granaryData.grainKind
      delete this.granaryData.grainNature
      delete this.granaryData.grainBelong
      delete this.granaryData.actualSize
      httpToken({
        url: '/barn-info-son/add',
        method: 'post',
        data: this.granaryData
      }).then(res => {
        if (res.data.code === 200) {
          this.$message({
            message: res.data.msg,
            type: 'success'
          })
          setTimeout(function () {
            _this.goBack()
          }, 1000)
        } else {
        }
      }).catch(err=>{
        _this.getBarnInfoData(_this.nowId)
      })
    },
    // 上传修改货位数据
    uploadGranary() {
      let _this = this
      httpToken({
        url: '/barn-info-son/update',
        method: 'post',
        data: this.granaryData
      }).then(res => {
        if (res.data.code === 200) {
          this.$message({
            message: res.data.msg,
            type: 'success'
          })
          setTimeout(function () {
            _this.goBack()
          }, 1000)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 返回货位管理页面
    goBack() {
      this.$emit('update:comName', 'BasicsGranary')
    },
    // 选择仓房返回，当前仓房的数量
    getBarnInfoData(id) {
      this.nowId=id
      // let paramData = [{column: "id", type: 'eq', value: id}];
      httpToken({
        url: '/barnInfo/showSchedule',
        method: 'post',
        data: qs.stringify({id: id,}),
      }).then(res => {
        let sumSize = 0
        let barnInfoSchedule = res.data.data
        let sons = barnInfoSchedule.data
        sons.forEach((item) => {
          sumSize = sumSize + item.sDSize
        })
        this.nowbarnDSize=barnInfoSchedule.barnDSize;
        this.nowsumSize=sumSize;
        this.barnInfoData = {
          title: barnInfoSchedule.barnName + '的当前容量', //标题内容
          color: "#376BF4", //主颜色
          bgcolor: "#C1D1FC", //背景条默认颜色
          value: (sumSize / 1000).toFixed(3), //当前值
          max: (barnInfoSchedule.barnDSize / 1000).toFixed(3), //上限
          unit: "吨", //单位
          settime: 500, //定时器的时长
        }
      })
    },
    // 详情编辑货位获取详细数据
    getGranaryDate() {
      let paramData = [{column: "id", type: 'eq', value: this.ids}]
      httpToken({
        url: '/barn-info-son/find',
        method: 'post',
        data: qs.stringify({paramData: JSON.stringify(paramData)})
      }).then(res => {
        // console.log(res.data.data)
        this.granaryData = res.data.data
        if (res.data.data.parentId){
          let designSize=res.data.data.designSize
          httpToken({
            url: '/barnInfo/showSchedule',
            method: 'post',
            data: qs.stringify({id: res.data.data.parentId,}),
          }).then(res => {
            let barnInfoSchedule = res.data.data
            this.nowbarnDSize=barnInfoSchedule.barnDSize;
            this.barnInfoData = {
              title: '此货位占 '+barnInfoSchedule.barnName + ' 的百分比容量', //标题内容
              color: "#376BF4", //主颜色
              bgcolor: "#C1D1FC", //背景条默认颜色
              value: (designSize / 1000).toFixed(3), //当前值
              max: (barnInfoSchedule.barnDSize / 1000).toFixed(3), //上限
              unit: "吨", //单位
              settime: 500, //定时器的时长
            }
          })
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.rightconover {
  height: 100%;
  background-color: #f5f6fa;
  overflow: auto;

  .contentwidth {
    width: 100%;

    .ContentMargin {
      box-sizing: border-box;
      margin: 30px 35px;
      background-color: #ffffff;
      box-shadow: 0 3px 5px 0 #d5dade;
      padding: 30px 80px;
    }
  }
}

.warehouse_in_top {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 40px;

  .warehousing_processes {
    flex: 1;

    .processes_img {
      width: 5vw;
      height: 5vw;
      margin: 0 auto 15px auto;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    .processes_font {
      text-align: center;
      color: #B2B2B2;
      font-size: 18px;
    }

    @media (max-width: 1366px) {
      .processes_font {
        font-size: 14px;
      }
    }

    .processes_font1 {
      color: #376BF4;
    }
  }

  .processes_guiding {
    width: 2vw;
    height: 2.5vh;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
}

.content_top {
  border-bottom: 1px solid #EBEBEB;
}

.content_down {
  margin-top: 32px;
}

.content_head {
  display: flex;
  font-size: 18px;
  margin-bottom: 50px;

  .content_head_ico {
    height: 17px;
    width: 4px;
    margin: auto 10px auto 0;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .content_head_title {
    margin: auto 0
  }

  .content_head_button {
    max-width: 70%;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    margin-left: auto;

    ::v-deep .el-button {
      padding: 10px 42px;
      font-size: 16px;

      span {
        font-size: 14px;
      }
    }

    .content_head_seek {
      display: inline-block;
      vertical-align: top;
      margin-left: 20px;
      margin-bottom: 20px;

      ::v-deep .el-input-group__append {
        padding: 0 18px;
      }

      .el-button {
        padding: 10px;
      }
    }
  }

  .highlight {
    ::v-deep .el-input__inner {
      border: 1px solid #376BF4;
    }

    ::v-deep .el-input__inner::-webkit-input-placeholder {
      color: #376BF4;
    }
  }
}

.content_element {
  margin-top: 50px;
  padding-bottom: 10px;
  text-align: right;
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  .content_element_only {
    width: 33.3333%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 38px;

    .content_element_only_title {
      width: 100px;
      margin-right: 15px;
      font-size: 14px;

      .significance {
        color: red;
      }
    }

    .content_element_only_value {
      width: 50%;
      text-align: left;
      font-size: 18px;
      color: dodgerblue;
    }

    ::v-deep .el-select {
      width: 50%;

      .el-input {
        width: 100%;
      }
    }

    ::v-deep .el-cascader {
      width: 50%;

      .el-input {
        width: 100%;
      }
    }

    /*样式穿透*/
    ::v-deep .el-input {
      //width:12.5vw;
      width: 50%;
      background: #F4F7FD;
    }

    ::v-deep .el-input__inner {
      height: 36px;
      line-height: 36px;
    }

    ::v-deep .el-input__icon {
      line-height: 36px;
    }
  }

  .content_element_slider {
    width: 33.3333%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 38px;

    .content_element_only_title {
      width: 140px;
      margin-right: 15px;
      font-size: 14px;
    }

    ::v-deep .el-slider__input {
      width: 50%;
    }
  }

  .content_element_remark {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;

    .content_element_only_title {
      width: 100px;
      margin-right: 15px;
      font-size: 14px;
    }

    /*样式穿透*/
    ::v-deep .el-textarea {
      width: 83.3%;
      background: #F4F7FD;

      textarea {
        font-family: "SourceHanSansCN", sans-serif;
      }
    }
  }

  .content_element_only_interval {
    margin-bottom: 40px;
  }

  .content_element_only_remark {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 38px;

    .content_element_only_title {
      width: 100px;
      margin-right: 15px;
      font-size: 14px;

      .significance {
        color: red;
      }
    }

    ::v-deep.el-textarea {
      width: 83.333%;
    }
  }
}
</style>

